import settings from '../settings.json';

const ABSOLUTE_URL = /^(?:[a-z][a-z0-9+.-]*:)?\/\//i;

export function getMediaBaseURL() {
  const base = process.env.NEXT_PUBLIC_MEDIA_URL ?? settings.mediaUri ?? '';
  return base.replace(/\/+$/, '');
}

export function getStrapiMediaURL(path) {
  if (!path) {
    return null;
  }

  if (ABSOLUTE_URL.test(path)) {
    return path;
  }

  return `${getMediaBaseURL()}${path.startsWith('/') ? path : `/${path}`}`;
}

export function getAbsoluteMediaURL(path) {
  const url = getStrapiMediaURL(path);

  if (!url || ABSOLUTE_URL.test(url)) {
    return url;
  }

  const host = settings.appUris[settings.appUris.length - 1];
  return `https://${host}${url}`;
}

export function isMediaCrossOrigin() {
  return getMediaBaseURL() !== '';
}

export function getStrapiMedia(media) {
  return getStrapiMediaURL(media?.data?.attributes?.url);
}
